// extracted by mini-css-extract-plugin
export default {"root":"Tooltip_root__-X6kR"};